import { useEffect } from "react";
import { FontSizes } from "../assets/fonts/fontSizes";

type ToastType = "success" | "error" | "info";

type Props = {
  message: string;
  onClose: () => void;
  durationMs?: number;
  type?: ToastType;
};

export default function Toast({
  message,
  onClose,
  durationMs = 2000,
  type = "info",
}: Props) {
  useEffect(() => {
    const t = window.setTimeout(onClose, durationMs);
    return () => window.clearTimeout(t);
  }, [durationMs, onClose]);

  return (
    <div
      style={{
        ...styles.wrap,
        ...(typeStyles[type] ?? {}),
      }}
      role="status"
      aria-live="polite"
    >
      {message}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  wrap: {
    position: "fixed",
    top: 24,
    left: "50%",
    transform: "translateX(-50%)",
    padding: "12px 16px",
    borderRadius: 10,
    fontSize: FontSizes.sm,
    fontWeight: 500,
    zIndex: 9999,
    maxWidth: 520,
    textAlign: "center",
    color: "#fff",
    boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
    animation: "toastFade 200ms ease-out",
    fontFamily: "Inter",
  },
};

const typeStyles: Record<ToastType, React.CSSProperties> = {
  success: {
    background: "#2E7D32", // green
  },
  error: {
    background: "#C62828", // red
  },
  info: {
    background: "rgba(0,0,0,0.85)",
  },
};
